import React, { useState } from "react";
import styles from "./ReviewWidget.module.scss";
import InnerTab from "./InnerTab";
import classNames from "classnames";
import _ from "lodash";

export const ReviewGrid = React.memo(({children, className, style, autosize, dataTestId}) => {
    return <div data-testid={dataTestId} className={classNames(styles['review-grid'], {[styles['auto-size']]: autosize}, className)} style={style}>
        {children}
    </div>
});

const Button = ({isActive, activeClassName, children, ...props}) => {
    return <button {...props}>{children}</button>
}

const ReviewWidget = React.memo(({ sections, children: _children = [], style, dataTestId }) => {
    const [currentSection, setCurrentSection] = useState(0);
    const children = _.isArray(_children) ? _children : [_children];

    return <div className={styles.base} style={style}>
        <InnerTab dataTestId={dataTestId} variant="card" expand={true}>
            {sections.map((section, index) => {
                return <React.Fragment key={index}>
                    <InnerTab.Button dataTestId={dataTestId && `${dataTestId}-${section}-tab`} isActive={currentSection === index} className={styles['link-no-shadow']}
                        onClick={() => { setCurrentSection(index) }}>{section}
                    </InnerTab.Button>
                </React.Fragment>
            })}
        </InnerTab>
        {children[currentSection]}
    </div>
});

export default ReviewWidget;
